import {RUN_FULL, RUN_HALF, RUN_RELAY} from './waypoint';

declare global {
    interface Window {
        config?: {
            paths?: Array<never>,
            themePath?: string,
            googleMapsApiKey?: string,
            environment?: string,
            language?: string,
        };
    }
}

type IconType = 'RUNNER_BLANK' | 'RUNNER' | 'TIME_NORMAL' | 'TIME_PASSED' | 'START' | 'FINISH' | 'HANDOVER' | 'CHARITY';
type IconVariant = 'default' | 'red' | 'turquoise' | 'dark' | 'blue';

export default class Icon {
    private static iconUrls: Record<IconType, {default: string, turquoise?: string, dark?: string, blue?: string}> = {
        RUNNER_BLANK: {
            default: '/images/marker/runner-blank-red.png',
            turquoise: '/images/marker/runner-blank-turquoise.png',
            blue: '/images/marker/runner-blank-blue.png',
            dark: '/images/marker/runner-blank-blueish-dark.png',
        },
        RUNNER: {
            default: '/images/marker/runner-red.png',
            turquoise: '/images/marker/runner-turquoise.png',
            blue: '/images/marker/runner-blue.png',
        },
        TIME_NORMAL: {
            default: '/images/marker/normal.png',
        },
        TIME_PASSED: {
            default: '/images/marker/passed-red.png',
            turquoise: '/images/marker/passed-turquoise.png',
            blue: '/images/marker/passed-blue.png',
        },
        START: {
            default: '/images/marker/start-red.png',
            turquoise: '/images/marker/start-turquoise.png',
            blue: '/images/marker/start-blue.png',
        },
        FINISH: {
            default: '/images/marker/finish-red.png',
            turquoise: '/images/marker/finish-turquoise.png',
            blue: '/images/marker/finish-blue.png',
        },
        HANDOVER: {
            default: '/images/marker/handover-red.png',
            turquoise: '/images/marker/handover-turquoise.png',
            blue: '/images/marker/handover-blue.png',
        },
        CHARITY: {
            default: '/images/marker/charity.png',
        },
    };

    static getIconVariantForRun(run: string): IconVariant {
        switch (run) {
            case RUN_HALF:
                return 'blue';
            case RUN_FULL:
            case RUN_RELAY:
            default:
                return 'default';
        }
    }

    static getUrl(iconType: IconType, variant: IconVariant = 'default'): string {
        const {themePath} = window.config;

        if (themePath && {}.hasOwnProperty.call(Icon.iconUrls, iconType)) {
            const variantsForType = Icon.iconUrls[iconType];
            if (variantsForType[variant]) {
                return `${themePath}${variantsForType[variant]}`;
            }

            return `${themePath}${variantsForType.default}`;
        }

        return '';
    }
}
